import {
  ACRONYMS as ACRONYMS_CCNA,
  GLOSSARY as GLOSSARY_CCNA,
  FLASHCARDS as FLASHCARDS_CCNA,
  QUESTIONS as QUESTIONS_CCNA,
  ARTICLES as ARTICLES_CCNA
} from  './ccna'

import {
  ACRONYMS as ACRONYMS_CCNP,
  GLOSSARY as GLOSSARY_CCNP,
  FLASHCARDS as FLASHCARDS_CCNP,
  QUESTIONS as QUESTIONS_CCNP,
  ARTICLES as ARTICLES_CCNP
} from  './ccnp'

export const BUNDLE_ACRONYMS = {
  'ccna': ACRONYMS_CCNA,
  'ccnp': ACRONYMS_CCNP
}
export const BUNDLE_GLOSSARY = {
  'ccna': GLOSSARY_CCNA,
  'ccnp': GLOSSARY_CCNP
}
export const BUNDLE_FLASHCARDS = {
  'ccna': FLASHCARDS_CCNA,
  'ccnp': FLASHCARDS_CCNP
}
export const BUNDLE_QUESTIONS = {
  'ccna': QUESTIONS_CCNA,
  'ccnp': QUESTIONS_CCNP
}
export const BUNDLE_ARTICLES = {
  'ccna': ARTICLES_CCNA,
  'ccnp': ARTICLES_CCNP
}

export const GET_TOTAL_QUESTIONS = (certificate) => {
  if (certificate == 'ccna') {
    return  QUESTIONS_CCNA.length;
  }
  else if (certificate == 'ccnp') {
    return  QUESTIONS_CCNP.length;
  }
  return QUESTIONS_CCNA.length;
}
